import styled from 'styled-components';
import { Row, Col } from 'antd';
import { maxWidth1300, minWidthApp } from 'Utils/utilsStyle';
import classNames from 'classnames';

const Wrapper = styled.div`
  overflow: hidden;
  .person-card-skeleton-row {
    margin-top: 15px;
  }
  .profile-left{
    display:flex;
    flex-direction:column;
    justify-items: center;
    position:relative;
    &:after {
      content: "";
      width: 1px;
      height: 92%;
      position: absolute;
      right: 0px;
      top: 0px;
      background-color: #F5F1EA;
    }
    .percentage-box{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-left: 70%;
      margin-bottom: -35px;
    }
    .image-box{
      width: 200px;
      height: 200px;
      border-radius:50%;
      margin: 0 auto 0 auto;
    }
    .badge-container {
      margin-top: -20px;
      margin-bottom: 10px;
      .disc-box {
        height: 35px;
        width: 35px;
        border-radius:50%;
        margin-left: 3%;
        margin-top: -5px;
      }
      .badge-box{
        width: 150px;
        height: 30px;
        box-shadow: 0px 0px 5px rgb(0 0 0 / 10%);
        margin-left: 31%;
        @media all and (max-width: ${minWidthApp}){
          margin-left: 70px;
        }
      }
    }
    .title-box{
      width: 70%;
      height:30px;
      border-radius:25px;
      margin: 0 auto;
      margin-bottom:10px;
      margin-top: 15px;
      @media all and (max-width: 1439px),
      (max-height: 729px),
      (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 0;
      }
      + .title-box{
        width: 55%;
      }
    }
    .title-small-box{
      border-radius:25px;
      margin: 5px auto 5px auto;
      width: 40%;
      height:18px;
    }
    .btn-box{
      border-radius:25px;
      margin: 30px auto;
      width: 90px;
      height:40px;
    }
  }
  .profile-right{
    padding: 0 45px;
    .button-box{
      width:100%;
      height:45px;
      margin-bottom: 15px;
      border-radius:8px;
    }
    .title-small-box{
      height:20px;
      width:50%;
    }
    .box-one{
      width: 70%;
    }
    .box-two{
      width: 50%;
    }
    .box-three{
      width: 65%;
    }
    .number-box{
      width:100%;
      height:100px;
      border-radius:7px;
    }
    .description-box{
      width:100%;
      height:100px;
      border-radius:7px;
      margin-top: 26px;
      margin-bottom: 34px;
    }
    .graph-box{
      width: 320px;
      height: 320px;
      border-radius: 50%;
      @media all and (max-width: ${maxWidth1300}) {
        width: 300px;
        height: 300px;
      }
      @media all and (max-width: ${minWidthApp}) {
        width: 200px;
        height: 200px;
      }
    }
    .users-row{
      .people-overlap-wrapper{
        position: relative;
        margin: 10px 0;
        z-index: 0;
        .user-box{
          width:70px;
          height:70px;
          border-radius:50%;
          + .user-box{
            margin-left:-16px;
          }
          @media all and (max-width: ${maxWidth1300}){
            width: 50px;
            height: 50px;
          }
        }
      }
    }
  }
  .skeleton-box {
    height: 20px;
    border-radius: 25px;
    width: 50px;
    &.nutanixTop {
     margin-top: 20px;
    }
  }
`;

type Props = {
  disclessPersonality?: boolean
} & typeof defaultProps;

const defaultProps = {
  disclessPersonality: false,
};

const PersonCardSkeleton = function PersonCardSkeleton(props: Props) {
  const { disclessPersonality } = props;
  return (
    <Wrapper className="person-card-skeleton">
      <Row className="person-card-skeleton-row">
        <Col xxl={{ span: 6 }} xl={{ span: 8 }} lg={{ span: 8 }}>
          <div className="profile-left">
            <span className="skeleton-box percentage-box" />
            <span className="skeleton-box image-box" />
            <div className="badge-container">
              {disclessPersonality ? null
                : (
                  <>
                    <span className="skeleton-box badge-box" />
                    <span className="skeleton-box disc-box" />
                  </>
                )}
            </div>
            <span className={classNames(
              'skeleton-box title-box',
              { nutanixTop: disclessPersonality },
            )}
            />
            <span className="skeleton-box title-box" />
            <div className="designation-box" />
            <span className="skeleton-box title-small-box" />
            <span className="skeleton-box title-small-box" />
            <span className="skeleton-box title-small-box" />
            <span className="skeleton-box btn-box" />
          </div>
        </Col>
        <Col xxl={{ span: 18 }} xl={{ span: 16 }} lg={{ span: 16 }}>
          <div className="profile-right">
            <span className="skeleton-box button-box" />
            <span className="skeleton-box title-small-box" style={{ marginBottom: '30px' }} />
            <Row gutter={14}>
              <Col span={12}>
                <Row gutter={16}>
                  <Col span={20} className="mb-c-30">
                    {/* <span className="skeleton-box number-box" /> */}
                    <span className="skeleton-box title-small-box box-one mb-c-10" />
                    <span className="skeleton-box title-small-box box-one mb-c-10" />
                    <span className="skeleton-box title-small-box box-two mb-c-10" />
                    <span className="skeleton-box title-small-box box-three" />
                  </Col>
                  {/* <Col span={8}>
                    <span className="skeleton-box number-box" />
                  </Col>
                  <Col span={8}>
                    <span className="skeleton-box number-box" />
                  </Col> */}
                  <Col span={20}>
                    {/* <span className="skeleton-box number-box" /> */}
                    <span className="skeleton-box title-small-box box-one mb-c-10" />
                    <span className="skeleton-box title-small-box box-two mb-c-10" />
                    <span className="skeleton-box title-small-box box-two mb-c-10" />
                    <span className="skeleton-box title-small-box box-three mb-c-10" />
                    <span className="skeleton-box title-small-box box-three" />
                  </Col>
                  {/* <Col span={12}>
                    <span className="skeleton-box number-box" />
                  </Col> */}
                </Row>
              </Col>
              <Col span={12} className="text-center">
                {
                  disclessPersonality ? null : <span className="skeleton-box graph-box" />
                }
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Wrapper>
  );
};

PersonCardSkeleton.defaultProps = defaultProps;
export default PersonCardSkeleton;